import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types

export const GboxMediaModalEvents = typedModal();

// Enums
import { Modals } from '../../enums/Modals';
import { MediaFormat } from '../../enums/Media';

// Mixins
import mixins from 'vue-typed-mixins';
import Paginatable from '../../mixins/Paginatable';
import Debouncable from '../../mixins/Debouncable';

// Style
import './GboxMedia.css';

// Utils
import { typedModal } from '../../utils/typedModals';
import { valueFromInput } from '../../utils/jsxHelpers';
import { copyToClipboard } from '../../utils/clipboard';

// Components
import GboxMediaUpload, { GboxMediaUploadModalEvents } from './GboxMediaUpload';
import AdminButton from '../ui/AdminButton';
const GboxMedia = mixins(GboxMediaModalEvents, Paginatable, GboxMediaUploadModalEvents, Debouncable({
  media: 500
})).extend({
  props: {
    limit: {
      type: [String, Number],
      default: 12
    },
    pageNumbersLength: {
      type: [String, Number],
      default: 5
    }
  },
  data() {
    var _sortOptions$find, _this$$application$st, _this$$application$st2;
    const sortOptions = [{
      name: this.$at('core.input.newestFirst'),
      param: 'created_at',
      order: 'desc',
      default: true
    }, {
      name: this.$at('core.input.oldestFirst'),
      param: 'created_at',
      order: 'asc'
    }, {
      name: this.$at('core.input.nameAToZ'),
      param: 'title',
      order: 'asc'
    }, {
      name: this.$at('core.input.nameZToA'),
      param: 'title',
      order: 'desc'
    }];
    const defaultSort = ((_sortOptions$find = sortOptions.find(option => option.default)) === null || _sortOptions$find === void 0 ? void 0 : _sortOptions$find.name) || '';
    return {
      sortOptions,
      options: {
        sort: defaultSort,
        mediaSize: ((_this$$application$st = this.$application.storage.mediaSizes) === null || _this$$application$st === void 0 ? void 0 : (_this$$application$st2 = _this$$application$st[0]) === null || _this$$application$st2 === void 0 ? void 0 : _this$$application$st2.key) || '',
        compression: MediaFormat.All
      },
      loading: false,
      compressions: [MediaFormat.All, MediaFormat.Avif, MediaFormat.Webp, MediaFormat.Jpeg, MediaFormat.Png],
      media: [],
      onConfirm: null,
      uploadProgress: null,
      recommendedSizes: [],
      size: ''
    };
  },
  async created() {
    var _this$$application$st3, _this$$application$st4, _this$$application$st5;
    if ((_this$$application$st3 = this.$application.storage.mediaSizes) !== null && _this$$application$st3 !== void 0 && _this$$application$st3.length) return;
    await this.$application.fetchMediaSizes();
    this.options.mediaSize = ((_this$$application$st4 = this.$application.storage.mediaSizes) === null || _this$$application$st4 === void 0 ? void 0 : (_this$$application$st5 = _this$$application$st4[0]) === null || _this$$application$st5 === void 0 ? void 0 : _this$$application$st5.key) || '';
  },
  computed: {
    sortedMediaSizes() {
      var _this$$application$st6;
      return ((_this$$application$st6 = this.$application.storage.mediaSizes) === null || _this$$application$st6 === void 0 ? void 0 : _this$$application$st6.sort((a, b) => {
        if (this.recommendedSizes.find(rSize => rSize.id === a.id)) {
          return -1;
        } else return 1;
      })) || [];
      // Filter out sizes which are not enabled inside Back Office
      // .filter((size) => size.autoResize) || []
    }
    // Media size used to render images inside GboxMedia modal, when user selects new size media wont unnecessarily refetch
    // renderedMediaSize(): MediaSize {
    //   const minX = 250
    //   const minY = 150
    //   const sizes = this.sortedMediaSizes.filter((size) => {
    //     const { x, y } = size
    //
    //     return parseInt(x) >= minX && parseInt(y) >= minY
    //   })
    //   const smallestX = Math.min(...sizes.map((size) => parseInt(size.x)))
    //   const size = sizes.find((size) => parseInt(size.x) === smallestX)
    //   return size || this.sortedMediaSizes[0]
    // },
  },

  watch: {
    'options.sort': 'fetchDataDebounced',
    'options.compression': 'fetchDataDebounced',
    'options.mediaSize': 'fetchDataDebounced'
  },
  methods: {
    beforeOpen(props) {
      var _props$params, _props$params2, _props$params3;
      this.recommendedSizes = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.recommendedSizes) || [];
      this.size = ((_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.size) || '';
      if (this.recommendedSizes.length) {
        this.options.mediaSize = this.recommendedSizes[0].key;
      }
      this.onConfirm = ((_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : _props$params3.onConfirm) || null;
      this.fetchMedia();
    },
    async fetchMedia() {
      this.loading = true;
      // TODO: pagination
      // const filters = {
      //   keywords: this.keywords,
      //   sort: {
      //     param: this.orderBy,
      //     order: this.order,
      //   },
      //   page: this.page,
      //   limit: 18,
      // }
      const {
        page,
        keywords,
        compression,
        mediaSize
      } = this.options;
      const activeSort = this.sortOptions.find(option => option.name === this.options.sort);
      const res = await this.$api.cms.media.filterStandard({
        limit: +this.limit,
        page,
        keywords,
        sort: {
          param: (activeSort === null || activeSort === void 0 ? void 0 : activeSort.param) || '',
          order: (activeSort === null || activeSort === void 0 ? void 0 : activeSort.order) || ''
        },
        size: mediaSize || '',
        compression
      });
      this.loading = false;
      if (res.errored) return;
      const m = this.media;
      m.splice(0, m.length, ...res.data.data);
      this.setPagination(res.data.pagination);
    },
    fetchDataDebounced() {
      this.debounce('media', this.fetchMedia);
    },
    async submit(media) {
      if (!this.onConfirm) return;
      this.onConfirm({
        ...media,
        size: this.options.mediaSize
      });
      this.$modal.hide(Modals.Media);
    },
    async handleFile(event) {
      var _target$files, _this$$application$do;
      const target = event.target;
      if (!((_target$files = target.files) !== null && _target$files !== void 0 && _target$files.length)) return;
      const file = target.files[0];
      const title = prompt('Title');
      if (!title) return;
      const description = prompt('Description');
      if (!description) return;
      const uploadRes = await this.$api.media.upload({
        file,
        customData: {
          directoryId: 'cms',
          access: 'public',
          resize: true,
          title,
          description
        },
        apiKey: ((_this$$application$do = this.$application.domain) === null || _this$$application$do === void 0 ? void 0 : _this$$application$do.apiKeyToken) || '',
        onUploadProgress: ({
          loaded,
          total
        }) => {
          this.uploadProgress = (loaded / total).toFixed(2);
        }
      });
      target.value = '';
      if (uploadRes.errored) return;
      this.uploadProgress = null;
      const driveId = uploadRes.data[0].userFileId;
      const mediaRes = await this.$api.cms.media.create(driveId);
      if (mediaRes.errored) return;
      this.$toast.success(this.$at('core.notifications.uploaded'));
      await this.fetchMedia();
    },
    async deleteMedia(media) {
      const res = await this.$api.media.directoryItem.delete([media.driveId]);
      if (res.errored) return;
      await this.$api.cms.media.delete(media.id);
      await this.fetchMedia();
    },
    copyURL(media) {
      const resourceURI = this.$cmsMedia({
        media
      });
      // From 0.107.0, $cmsMedia can also return array of strings which means that there are alternative links to different file formats in case selected compression is 'default'
      // where array indices will correspond to formats: 0:.avif, 1:.webp, 2:.jpeg, 3:.png
      // Safari doesnt work with avif, so we will always use the .webp one for copying url if selected compression is default
      const computedURI = Array.isArray(resourceURI) && resourceURI.length ? resourceURI.find(uri => uri.endsWith('.webp')) || '' : resourceURI;
      const resourceURL = new URL(computedURI, window.location.origin).href;
      copyToClipboard(resourceURL);
      this.$toast.success(this.$at('core.notifications.copiedToClipboard'));
    },
    refreshOnMediaUpload() {
      if (this.options.sort === this.$at('core.input.newestFirst')) {
        this.setPage(1, true);
      } else {
        const newTotalItems = this.paginationState.totalItems + 1;
        const newNumberOfPages = Math.ceil(newTotalItems / +this.limit);
        this.setPage(newNumberOfPages, true);
      }
    }
  },
  render() {
    const h = arguments[0];
    return h("modal", _mergeJSXProps([{
      "attrs": {
        "name": Modals.Media,
        "id": Modals.Media,
        "height": "90%",
        "width": "90%",
        "clickToClose": false
      }
    }, {
      "on": {
        'before-open': this.beforeOpen
      }
    }]), [h("div", {
      "class": "h-full py-6 px-8 flex flex-col"
    }, [h("div", {
      "class": "flex justify-between h-10 mb-6"
    }, [h("div", [h("h3", {
      "class": "text-gray-700 text-3xl title-font font-medium"
    }, [this.$at('core.modals.media')])]), h("div", {
      "class": "w-3/4"
    }, [h("input", {
      "class": "p-2 rounded-sm border w-3/5 inline-block",
      "attrs": {
        "type": "search",
        "placeholder": this.$at('core.action.searchMedia').toString()
      },
      "domProps": {
        "value": this.options.keywords
      },
      "on": {
        "input": valueFromInput(v => this.options.keywords = v)
      }
    }), h("div", {
      "class": 'flex items-center w-2/5 inline-flex'
    }, [h("label", {
      "attrs": {
        "for": "media-size"
      },
      "class": "inline-block w-2/5 align-top pl-2"
    }, [this.$at('core.input.orderBy'), ":"]), h("select", {
      "class": "inline-block w-3/5 rounded-sm px-2 py-1 bg-gray-200 shadow-inner",
      "domProps": {
        "value": this.options.sort || undefined
      },
      "on": {
        "change": valueFromInput(v => this.options.sort = v)
      }
    }, [this.sortOptions.map(option => h("option", {
      "domProps": {
        "value": option.name
      },
      "key": option.name
    }, [option.name]))])])])]), h("div", {
      "class": 'overflow-y-auto flex-grow'
    }, [h("div", {
      "class": "grid grid-cols-4 gap-4"
    }, [this.media.map(media => h("div", {
      "key": media.id,
      "class": "shadow-md"
    }, [h("div", {
      "class": "flex justify-between items-center h-8 px-2 bg-gray-700 text-white rounded rounded-b-none"
    }, [h("span", {
      "class": 'truncate'
    }, [media.title]), h("button", {
      "class": 'ml-2',
      "on": {
        "click": () => this.deleteMedia(media)
      }
    }, [h("em", {
      "class": "core-icon-times"
    })])]), h("cms-image", {
      "class": "h-32 w-full object-cover cursor-pointer border-t border-b border-gray-600",
      "attrs": {
        "media": media,
        "controls": true
      }
    }), h("div", {
      "class": "flex justify-between items-center py-1 px-1 rounded rounded-t-none bg-gray-700 text-white"
    }, [h("button", {
      "class": 'text-white rounded-sm text-black px-2 bg-blue-600 border border-blue-500',
      "on": {
        "click": () => this.copyURL(media)
      }
    }, [this.$at('core.action.copyURL')]), this.onConfirm && h("button", {
      "class": 'text-white rounded-sm text-black px-2 bg-blue-600 border border-blue-500',
      "on": {
        "click": () => this.submit(media)
      }
    }, [this.$at('core.action.select')])])]))])]), h("div", {
      "class": "flex justify-center space-x-2 mt-6"
    }, [h(AdminButton, {
      "attrs": {
        "secondary": true,
        "disabled": this.options.page === 1
      },
      "class": 'w-10',
      "on": {
        "click": () => this.firstPage()
      }
    }, ['<<']), h(AdminButton, {
      "attrs": {
        "secondary": true,
        "disabled": this.options.page === 1
      },
      "class": 'w-10',
      "on": {
        "click": () => this.previousPage()
      }
    }, ['<']), this.pageNumbers.map(page => h(AdminButton, {
      "on": {
        "click": () => this.options.page = page
      },
      "attrs": {
        "secondary": this.options.page !== page
      },
      "class": 'w-10'
    }, [page])), h(AdminButton, {
      "attrs": {
        "secondary": true,
        "disabled": this.paginationState.onLastPage
      },
      "class": 'w-10',
      "on": {
        "click": () => this.nextPage()
      }
    }, ['>']), h(AdminButton, {
      "attrs": {
        "secondary": true,
        "disabled": this.paginationState.onLastPage
      },
      "class": 'w-10',
      "on": {
        "click": () => this.lastPage()
      }
    }, ['>>'])]), h("div", {
      "class": "mt-6 flex justify-between"
    }, [h("div", {
      "class": 'flex items-center space-x-6'
    }, [h("div", [h("label", {
      "attrs": {
        "for": "media-size"
      },
      "class": "inline-block align-top"
    }, [this.$at('core.input.mediaSize'), ":"]), h("select", {
      "attrs": {
        "id": "media-size"
      },
      "class": "inline-block ml-2 rounded-sm px-2 py-1 bg-gray-200 shadow-inner",
      "domProps": {
        "value": this.options.mediaSize
      },
      "on": {
        "input": valueFromInput(v => this.options.mediaSize = v)
      }
    }, [h("option", {
      "attrs": {
        "value": ""
      }
    }, [this.$t('core.input.originalSize')]), this.sortedMediaSizes.map(mediaSize => h("option", {
      "domProps": {
        "value": mediaSize.key
      }
    }, [mediaSize.key, " ", mediaSize.value, ' ', this.recommendedSizes.find(rSize => rSize.id === mediaSize.id) ? '(Recommended)' : undefined]))])]), this.size && h("span", {
      "class": 'ml-2'
    }, [this.$at('core.input.recommendedSize') + ': ' + this.size]), h("div", [h("label", {
      "attrs": {
        "for": "media-compression"
      },
      "class": "inline-block align-top"
    }, ["Format :"]), h("select", {
      "attrs": {
        "id": "media-compression"
      },
      "class": "inline-block ml-2 rounded-sm px-2 py-1 bg-gray-200 shadow-inner",
      "domProps": {
        "value": this.options.compression
      },
      "on": {
        "input": valueFromInput(v => this.options.compression = v)
      }
    }, [this.compressions.map(compression => h("option", {
      "domProps": {
        "value": compression
      }
    }, [compression === MediaFormat.All ? 'Default' : compression]))])])]), h("div", {
      "class": 'flex space-x-4'
    }, [h(AdminButton, {
      "attrs": {
        "secondary": true
      },
      "on": {
        "click": () => this.$modal.hide(Modals.Media)
      }
    }, [this.$at('core.action.close')]), h(AdminButton, {
      "on": {
        "click": () => this.$modal.show(Modals.MediaUpload)
      }
    }, [this.$at('core.action.upload')])])])]), h(GboxMediaUpload, {
      "on": {
        "media-uploaded": () => this.refreshOnMediaUpload()
      }
    })]);
  }
});
export default GboxMedia;